import { externalDestroyExternalCourseCertificatesSaga } from './destroyMany.saga'
import { externalCoursesCertificatesListWatcherSaga } from './list.saga'

export const root = [
  externalDestroyExternalCourseCertificatesSaga(),
  externalCoursesCertificatesListWatcherSaga(),
]

export default root
